export default {
    methods: {
        getWAStatusDescription(status) {
            let stausDescription
            switch (status) {
                case 0:
                    stausDescription = 'PROPOSED'
                    break
                case 1:
                    stausDescription = 'CONFIRMED'
                    break
                case 2:
                    stausDescription = 'DENIED'
                case 3:
                    stausDescription = 'EXPECTED'    
                    break
                default:
                    break
            }
            return stausDescription
        },
    },
}
